/**
 * Utility functions for ProcessTaskSchemaEditor
 */

/**
 * Creates a map from organization ID to registry ID.
 * Since each organization has exactly one registry, this provides a 1:1 mapping.
 */
export function createOwnerToRegistryMap(
  registries: Array<{id: string; organization: {id: string}}>
): Map<string, string> {
  const map = new Map<string, string>();
  for (const registry of registries) {
    // Since 1 org = 1 registry, this should always be a 1:1 mapping
    map.set(registry.organization.id, registry.id);
  }
  return map;
}

/**
 * Gets the registry ID for a given organization/owner ID.
 * Returns undefined if no registry is found for the organization or if the map is not provided.
 */
export function getRegistryIdForOwner(
  ownerId: string,
  ownerToRegistryMap: Map<string, string> | undefined
): string | undefined {
  return ownerToRegistryMap?.get(ownerId);
}
